import React, { useEffect, useState } from 'react';
import ApiUrl from '../../utils/config';
import { Person, PersonClient } from '../../utils/apiClient';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AppContext from '../../AppContext';
import { handleError } from '../../utils';
import CreatePersonModal from '../TournamentDetail/CreatePersonModal';

export const PersonList = () => {
  const appContext = React.useContext(AppContext);
  const [persons, setPersons] = useState<Person[]>([]);
  const [loading, setLoading] = useState(true);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const navigate = useNavigate();
  const personClient = new PersonClient(ApiUrl, axios);

  useEffect(() => {
    const fetchPersons = async () => {
      try {
        const data = await personClient.getPersons();
        setPersons(data);
      } catch (ex) {
        handleError(appContext!.setNotificationData, ex);
      } finally {
        setLoading(false);
      }
    };

    fetchPersons();
  }, []);

  if (loading) {
    return <div>Loading people...</div>;
  }

  return (
    <div className="persons-page">
      <div className="persons-page__header">
        <h2>Люди</h2>
        <button onClick={() => setIsCreateModalOpen(true)} className="btn">+ Новый участник</button>
      </div>

      {persons.length === 0 ? (
        <p>Людей не найдено</p>
      ) : (
        <div className="persons-page__list">
          <table>
            <thead>
              <tr>
                <th>Имя</th>
                <th>Дата рождения</th>
                <th>Город</th>
                <th>Роли</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {persons.map((person) => (
                <tr key={person.id}>
                  <td>{person.lastName} {person.firstName} {person.patronymic || ''}</td>
                  <td>{new Date(person.birthDate).toLocaleDateString()}</td>
                  <td>{person.city}</td>
                  <td>
                    {person.personRoles && person.personRoles.map(pr =>
                      pr.role?.name
                    ).join(', ')}
                  </td>
                  <td>
                    <button onClick={() => navigate(`/persons/${person.id}`)} className="btn btn--view">Просмотр</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <CreatePersonModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onPersonCreated={async (person) => {
          setIsCreateModalOpen(false);
          // Обновляем список после создания
          try {
            const data = await personClient.getPersons();
            setPersons(data);
          } catch (ex) {
            handleError(appContext!.setNotificationData, ex);
          }
          // Открываем профиль созданного участника
          navigate(`/persons/${person.id}`);
        }}
      />
    </div>
  );
};